module.exports = __webpack_public_path__ + "img/middleCarouseImg2.c84f8007.jpg";